var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.link.type == 'link')?_c('i',{staticClass:"link-icon fa fa-external-link"}):(_vm.link.icon)?_c('img',{staticClass:"link-icon",attrs:{"src":_vm.getIconImage(_vm.link)}}):(_vm.link.mime)?_c('span',{staticClass:"link-icon",class:_vm.$filters.mimeIcon(_vm.link.mime)}):_c('span',{staticClass:"link-icon fas fa-paperclip"})
}
var staticRenderFns = []

export { render, staticRenderFns }